import { render, staticRenderFns } from "./TursysLogin.vue?vue&type=template&id=1857610f&scoped=true&"
import script from "./TursysLogin.vue?vue&type=script&lang=js&"
export * from "./TursysLogin.vue?vue&type=script&lang=js&"
import style0 from "./TursysLogin.vue?vue&type=style&index=0&id=1857610f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857610f",
  null
  
)

export default component.exports